import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  assignProduct,
  getPartitionsArrangementByTray,
  productRemoval,
} from "data/server_apis/vendingServices";

const initialState = {
  items: {},
  loading: {},
  error: {},
  errorMessage: {},
  success: {},
};

export const getPartitionsArrangementByTrayThunk = createAsyncThunk(
  "refill/getPartitions",
  async (id, { rejectWithValue }) => {
    try {
      return (await getPartitionsArrangementByTray(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const assignProductThunk = createAsyncThunk(
  "product/assignProduct",
  async ({ tray, data }, { rejectWithValue }) => {
    try {
      return (await assignProduct(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const productRemovalThunk = createAsyncThunk(
  "product/productRemoval",
  async ({ tray, data }, { rejectWithValue }) => {
    try {
      return (await productRemoval(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
const refillSlice = createSlice({
  name: "refill",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPartitionsArrangementByTrayThunk.pending, (state, action) => {
        state.loading = { list_partitions: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(
        getPartitionsArrangementByTrayThunk.rejected,
        (state, action) => {
          state.loading = {};
          state.error = { list_partitions: true };
          state.success = {};
          state.errorMessage = { list_partitions: action.payload?.message };
        }
      )
      .addCase(
        getPartitionsArrangementByTrayThunk.fulfilled,
        (state, action) => {
          state.loading = {};
          state.error = {};
          state.success = { list_partitions: true };
          state.errorMessage = {};
          state.items[action.meta.arg] = action.payload;
        }
      );

    builder
      .addCase(assignProductThunk.pending, (state, action) => {
        state.loading = { assign_product: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(assignProductThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { assign_product: true };
        state.success = {};
        state.errorMessage = { assign_product: action.payload?.message };
      })
      .addCase(assignProductThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { assign_product: true, tray: action.meta.arg.tray };
        state.errorMessage = {};
      });

    builder
      .addCase(productRemovalThunk.pending, (state, action) => {
        state.loading = { remove_product: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(productRemovalThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { remove_product: true };
        state.success = {};
        state.errorMessage = { remove_product: action.payload?.message };
      })
      .addCase(productRemovalThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { remove_product: true, tray: action.meta.arg.tray };
        state.errorMessage = {};
      });
  },
});

export const {} = refillSlice.actions;

export default refillSlice.reducer;
